module.exports = __webpack_public_path__ + "static/img/viewAv2.f7846488.png";